import { c as _c } from "react/compiler-runtime";
import useCurrency from '@/contexts/i18nContext/hooks/useCurrency';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { DiscountTagIcon } from '@winelidays/wld-tsx-2/images';
import { capitalize, formatPrice } from '@winelidays/wld-tsx-2/utils';
const DiscountDetailLine = (t0) => {
    const $ = _c(10);
    const { discountAmount } = t0;
    const translate = useTranslate();
    const { symbol: currencySymbol } = useCurrency();
    let t1;
    if ($[0] !== translate) {
        t1 = capitalize(translate("messages.discount_code"));
        $[0] = translate;
        $[1] = t1;
    }
    else {
        t1 = $[1];
    }
    const label = t1;
    const value = `-${translate("messages.price_with_currency", { price: formatPrice(discountAmount), currencySymbol })}`;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = <DiscountTagIcon className="!w-5 mr-2"/>;
        $[2] = t2;
    }
    else {
        t2 = $[2];
    }
    let t3;
    if ($[3] !== label) {
        t3 = <span className="text-gray-400 inline-flex">{t2}
      {label}
    </span>;
        $[3] = label;
        $[4] = t3;
    }
    else {
        t3 = $[4];
    }
    let t4;
    if ($[5] !== value) {
        t4 = <span>{value}</span>;
        $[5] = value;
        $[6] = t4;
    }
    else {
        t4 = $[6];
    }
    let t5;
    if ($[7] !== t3 || $[8] !== t4) {
        t5 = <div className="flex flex-row justify-between py-1">{t3}{t4}
    </div>;
        $[7] = t3;
        $[8] = t4;
        $[9] = t5;
    }
    else {
        t5 = $[9];
    }
    return t5;
};
export default DiscountDetailLine;
